import { render, staticRenderFns } from "./fidelior-navigation.vue?vue&type=template&id=1f9aa0f9&"
import script from "./fidelior-navigation.vue?vue&type=script&lang=js&"
export * from "./fidelior-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports